import { render, staticRenderFns } from "./TransactionHistoryModal.vue?vue&type=template&id=8b3a71a6&"
import script from "./TransactionHistoryModal.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryModal.vue?vue&type=style&index=0&sccoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VIcon,VProgressLinear,VSimpleTable})
